import React from 'react';
import TextField from '@guestyci/foundation/next/TextField';

const Title = ({ children }) => (
  <TextField variant="h2" align="center">
    {children}
  </TextField>
);
export default Title;
